import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LabpartnerService } from 'src/app/services/labpartner.service';
import { PAGE_NAME_PRINTAVERYSHEET } from 'src/app/services/logging-constants';
import { LoggingService } from 'src/app/services/logging.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { BaseDetailListPrintFormatsComponent } from '../detail-list-print/BaseDetailListPrintFormats.component';

@Component({
  selector: 'app-detail-list-print-avery',
  templateUrl: './detail-list-print-avery.component.html',
  styleUrls: ['./detail-list-print-avery.component.scss'],
  standalone: false,
})
export class DetailListPrintAveryComponent
  extends BaseDetailListPrintFormatsComponent
  implements OnInit
{
  skipRowOptions: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  selectedSkipRowOption: number = 0;
  get skipRows() {
    return [...Array(this.selectedSkipRowOption).keys()];
  }

  private _defaultLabelsPerPage = 80;

  constructor(
    apiService: LabpartnerService,
    route: ActivatedRoute,
    loggingService: LoggingService,
    public notificationService: NotificationService,
  ) {
    super(apiService, route, loggingService, notificationService);

    this.LABELS_PER_ROW = 8;
    this.LABELS_PER_PAGE = this._defaultLabelsPerPage;
    this.LABELS_ON_FIRST_PAGE = this._defaultLabelsPerPage;
  }

  ngOnInit(): void {
    this.OnInit(PAGE_NAME_PRINTAVERYSHEET);
  }

  protected ngOnDestroyInternal(): void {
    // required by base component. clean up any component specific resources
  }

  onSkipRowChange(value: number) {
    this.LABELS_ON_FIRST_PAGE = this._defaultLabelsPerPage - this.LABELS_PER_ROW * value;
  }
}
